import { render, staticRenderFns } from "./GreenList.vue?vue&type=template&id=08e22c6a&scoped=true"
import script from "./GreenList.vue?vue&type=script&lang=js"
export * from "./GreenList.vue?vue&type=script&lang=js"
import style0 from "./GreenList.vue?vue&type=style&index=0&id=08e22c6a&prod&lang=less&scoped=true"
import style1 from "./GreenList.vue?vue&type=style&index=1&id=08e22c6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e22c6a",
  null
  
)

export default component.exports